import {AuthService} from "../../core/auth/auth.service";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {UrlsResources} from "../../core/urls-resources";
import {LocalStorageService} from "../../core/storage/storage.service";
import {Router} from "@angular/router";
import { HandleError } from '../../core/handle-error';

@Injectable()
export class WebAuthService extends AuthService {
  constructor(httpClient: HttpClient,
              urlsResources: UrlsResources,
              handleError: HandleError,
              localStorageService: LocalStorageService,
              private router: Router) {
    super(httpClient, urlsResources, handleError, localStorageService);
  }

  goToLoginPage() {
    console.log("WebAuthService#goToLoginPage");
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/common/web-auth.service.ts